module.exports = "pegasus/assets/email1-column-7.png";